import React from 'react';
import { Users, Wrench, Smartphone, Home } from 'lucide-react';
import { howItWorksSteps } from '../mock';
import Reveal from './Reveal';

const iconMap = { Users, Wrench, Smartphone, Home };

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="bg-[#0B1430] py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal variant="up">
          <div className="text-center mb-14">
            <div className="text-[#D4A853] tracking-[0.3em] text-xs font-semibold mb-3">HOW IT WORKS</div>
            <h2 className="text-3xl md:text-4xl font-bold text-white">Simple Steps to a Smarter Home</h2>
          </div>
        </Reveal>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-8">
          {howItWorksSteps.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <Reveal key={s.title} variant="up" delay={i * 180}>
                <div className="relative flex flex-col items-center text-center px-4">
                  {/* Dotted connector */}
                  {i < howItWorksSteps.length - 1 && (
                    <div className="hidden md:block absolute top-[40px] left-[60%] right-[-40%] step-connector" />
                  )}
                  <div className="relative z-10 w-20 h-20 rounded-full bg-[#D4A853]/15 border-2 border-[#D4A853] flex items-center justify-center mb-5">
                    <Icon size={32} className="text-[#D4A853]" strokeWidth={1.6} />
                  </div>
                  <h3 className="text-white font-semibold text-lg mb-2">{i + 1}. {s.title}</h3>
                  <p className="text-white/70 text-sm leading-relaxed max-w-[220px]">{s.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
